import {
  getPageType,
  getSessionData,
  getVersionedCallbackUrl,
  redirectToWebform,
} from "@repo/shared-utils/common-utils";
import { commonInsertParameters } from "@repo/shared-utils/insert-params";
import { getApplicationIdAndProdCode, getApplicationId } from "./utils";
import { ucfInsert, offerAPI, deleteFromCartApi } from "@repo/connection-manager";
import { PROD_CODES } from "@repo/shared-utils/cart";
import { PDP_DETAILS, WHEELS_OFFER } from "../../../api-client/src/constants/util";
import type { SSORedirectHandler } from "../types/SSO.types";

type CarModule = "zcuc" | "zlc" | "zbt";
const PRODUCT_CONFIG: Record<
  CarModule,
  {
    productName: "ZCUC" | "ZLC" | "ZBT";
    journeyName: string;
    prodCode: keyof typeof PROD_CODES;
    appModule: "UCL" | "LAC" | "CLBT";
    offerProduct: "ucf_sp" | "ucf_lac" | "ucf_albt";
  }
> = {
  zcuc: {
    productName: "ZCUC",
    journeyName: "ZCUC_NTB",
    prodCode: "UCF_SP",
    appModule: "UCL",
    offerProduct: "ucf_sp",
  },
  zlc: {
    productName: "ZLC",
    journeyName: "ZLC_NTB",
    prodCode: "UCF_LAC",
    appModule: "LAC",
    offerProduct: "ucf_lac",
  },
  zbt: {
    productName: "ZBT",
    journeyName: "ZBT_NTB",
    prodCode: "UCF_ALBT",
    appModule: "CLBT",
    offerProduct: "ucf_albt",
  },
};

const INSERT_OPTIONS: Parameters<typeof commonInsertParameters>[0] = {
  appVersion: "v4",
  pwaVersion: "5.1.9",
};

const API_VERSION = "P.11.1.4";

export const carLoanHandler: SSORedirectHandler = async (data) => {
  const { mobileNo, custId, custType } = await getSessionData();
  const module = data.mapping.ssoModule as CarModule;
  const config = PRODUCT_CONFIG[module];
  const isDpaopPdpPage = getPageType("template") === "dpaop-pdp-page-content";

  const [applicationID, prodCode] = await getApplicationIdAndProdCode(data, [config.prodCode]);
  let response = undefined;
  const resume = applicationID !== undefined;

  const appId = await getApplicationId([config.prodCode]);
  if (appId) {
    await deleteFromCartApi({ appId, mobileNo, channel: "3in1" });
  }
  const [offer] = (await offerAPI(config.offerProduct)) ?? [];
  response = await ucfInsert({
    ...commonInsertParameters(isDpaopPdpPage ? INSERT_OPTIONS : {}),
    mobileNo,
    custId,
    custType,
    journeyName: config.journeyName,
    prodName: config.productName,
    eventCode: WHEELS_OFFER,
    eventName: PDP_DETAILS,
    offerId: offer?.offerId ?? "",
    offerName: offer?.offerName ?? "",
    offerAmt: offer?.icorsAmount ?? "",
    apiVersion: API_VERSION,
    ...data.data?.ucfInsert,
  });

  const callbackUrl = await getVersionedCallbackUrl(data.mapping);
  redirectToWebform(
    callbackUrl.toString(),
    {
      ...response,
      applicationID: response?.id ?? applicationID,
      prodCode: response?.id ? "" : prodCode,
      product: config.productName,
      custType,
      resume: false,
    },
    `used_car_finance/${config.appModule}/${resume ? "resume" : "new"}`
  );
};
